import {useState, useContext, Fragment} from "react";
import { Link, withRouter } from "react-router-dom";
import { Home } from '@material-ui/icons';
import { FlexRowDiv } from './menuStyle';
import MenuIcon from '@material-ui/icons/Menu';
import styled from 'styled-components';
import Collapse from '@material-ui/core/Collapse';
import UserMenus from './menus';
import DropDownMenu from './dropDownMenu';
import { AppContext } from "../../context/appContext";

const IconContainer = styled.div`
cursor: pointer;
display: flex;
align-items: center;
padding: 0px 8px;
&:hover {
  background-color: #3a3c3f;
}
`;

const loginMenus = [ {name: 'My Account', link:'/myaccount'},
                {name: 'Manage User', link:'/usermanage'},
                {name: 'Create User', link:'/createuser'},            
              ];

const MobileNavBarComponent = (props) => {
  const { CurrentUser, dispatch } = useContext(AppContext);
  const [showMenu, setShowMenu ] = useState(false);

  return (
    <div style={{width: '100%', display: 'flex', flexDirection: 'column'}}>
      <div style={{display: 'flex', justifyContent: 'space-between'}}>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <Link style={{ textDecoration: 'none', marginRight: '10px' }} to="/">
            <FlexRowDiv>
              <Home fontSize="small" />
              <span style={{marginLeft: '6px'}}>Home</span>
            </FlexRowDiv>
          </Link>
        </div>
        <div style={{display: 'flex', flexDirection:'row'}}>
          <IconContainer onClick={() => setShowMenu((prev) => !prev) }>
            <MenuIcon style={{color: '#FFFFFF', width: '20px', height: '20px'}} />
          </IconContainer>
        </div>
      </div>
      <div>
        <Collapse in={showMenu}>
          <div>
            {CurrentUser && UserMenus.map((menu, index) => {
              return <DropDownMenu key={index} title={menu.name} link={menu.link} menus={menu.submenus} collapsible={true} />
            })}
            { CurrentUser &&
              <Fragment>
                <DropDownMenu showPerson={true} title={`${CurrentUser.firstname} ${CurrentUser.lastname}`} link={''} menus={loginMenus} collapsible={true} />
                <FlexRowDiv onClick={() => {
                  dispatch({type: 'LOGOUT'});
                  document.location.href = '/';
                }}>
                  Logout
                </FlexRowDiv>
              </Fragment>
            }
            { !CurrentUser &&
              <Fragment>
                <Link style={{ textDecoration: 'none'}} to="/signin">
                  <FlexRowDiv>
                    Sign In
                  </FlexRowDiv>
                </Link>
              </Fragment>
            }
            <FlexRowDiv onClick={() => window.location = "mailto: escworkshelp@esc4.net?subject=Scorecard Question"}>
              <img src="/assets/images/help.png" alt="" style={{width: '30px', height: '30px', marginRight: '10px'}} />
              Help
            </FlexRowDiv>
          </div>
        </Collapse>

      </div>
    </div>

  );
}

export default withRouter(MobileNavBarComponent);

